import React from 'react';
import { Panel, Tiles, Tile } from './servicemap.style';

// The 17 items a Savings Scan checks, from the app's providers
// (src/main/adapters/insights/providers/providerFactory.js) as listed in
// wi/WI-020 facts-D3. Icons are the unmodified SVGs of the official AWS
// Architecture Icons package (release 07312026, static/aws-icons/). Services
// without an architecture icon of their own use the resource icon of that
// feature. Bedrock is not a Savings Scan service, so it stays outside the grid.
// `plain` marks resource icons: transparent glyphs, shown on a light tile.
const SERVICES = [
  ['Amazon EC2', 'Arch_Amazon-EC2_64'],
  ['Amazon EBS', 'Arch_Amazon-Elastic-Block-Store_64'],
  ['EBS Snapshots', 'Res_Amazon-Elastic-Block-Store_Snapshot_48', true],
  ['NAT Gateway', 'Res_Amazon-VPC_NAT-Gateway_48', true],
  ['Elastic IP', 'Res_Amazon-EC2_Elastic-IP-Address_48', true],
  ['Amazon VPC', 'Arch_Amazon-Virtual-Private-Cloud_64'],
  ['Elastic Load Balancing', 'Arch_Elastic-Load-Balancing_64'],
  ['AWS Lambda', 'Arch_AWS-Lambda_64'],
  ['Amazon EKS', 'Arch_Amazon-Elastic-Kubernetes-Service_64'],
  ['Amazon ECR', 'Arch_Amazon-Elastic-Container-Registry_64'],
  ['Amazon S3', 'Arch_Amazon-Simple-Storage-Service_64'],
  ['Amazon EFS', 'Arch_Amazon-EFS_64'],
  ['Amazon RDS', 'Arch_Amazon-RDS_64'],
  ['Amazon DynamoDB', 'Arch_Amazon-DynamoDB_64'],
  ['Amazon DocumentDB', 'Arch_Amazon-DocumentDB_64'],
  ['AWS Glue', 'Arch_AWS-Glue_64'],
  ['CloudWatch Logs', 'Res_Amazon-CloudWatch_Logs_48', true],
];

const ServiceMap = () => (
  <Panel aria-labelledby="service-map-title">
    <h3 id="service-map-title">
      One Savings Scan puts a dollar figure on the waste in all of these
    </h3>
    <Tiles>
      {SERVICES.map(([name, file, plain]) => (
        <Tile key={name}>
          <span className={plain ? 'icon plain' : 'icon'} aria-hidden="true">
            <img src={`/aws-icons/${file}.svg`} alt="" width="44" height="44" />
          </span>
          <span className="name">{name}</span>
        </Tile>
      ))}
    </Tiles>
  </Panel>
);

export default ServiceMap;
